module.exports = __webpack_public_path__ + "assets/search.f4adf4be.svg";